var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File / File_Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.00016 9.66683V5.66683C5.00016 4.73341 5.00016 4.26635 5.18182 3.90983C5.34161 3.59623 5.59639 3.34144 5.90999 3.18166C6.26651 3 6.73357 3 7.66699 3H11.3958C11.4979 3 11.5872 3 11.6668 3.00072M16.666 8C16.6668 8.07967 16.6668 8.16913 16.6668 8.2714V15.3363C16.6668 16.2679 16.6668 16.7337 16.4854 17.0899C16.3256 17.4035 16.0701 17.6587 15.7565 17.8185C15.4003 18 14.9343 18 14.0027 18L10.8335 18M16.666 8C16.6638 7.76209 16.6549 7.61146 16.6204 7.46777C16.5796 7.29771 16.512 7.13512 16.4206 6.986C16.3176 6.8178 16.1742 6.67407 15.886 6.38582L13.2814 3.78125C12.9933 3.49318 12.849 3.34881 12.6808 3.24577C12.5317 3.15439 12.3693 3.08688 12.1992 3.04605C12.0554 3.01154 11.9049 3.00289 11.6668 3.00072M16.666 8H16.667M16.666 8H14.3309C13.3993 8 12.9328 8 12.5767 7.81852C12.2631 7.65873 12.0083 7.40326 11.8485 7.08966C11.6668 6.73314 11.6668 6.26675 11.6668 5.33333V3.00072M7.50016 12.1667L9.16683 13.8333M3.3335 18V15.9167L9.5835 9.66667L11.6668 11.75L5.41683 18H3.3335Z",
    stroke: "#B4B4C4",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFile);
export default __webpack_public_path__ + "static/media/edit_file.b8a75c14cf6fae82c5bce66a6e665e56.svg";
export { ForwardRef as ReactComponent };